<script setup lang="ts">
import { computed } from "vue"
import { useTasksStore } from "@/stores/v2"

const filters = computed(() => useTasksStore().getFilters);
const activeFilter = computed(() => useTasksStore().getActiveFilter)
const typeFilters = computed(() => useTasksStore().getTypeFilters);
const activeTypeFilter = computed(() => useTasksStore().getActiveTypeFilter);

const handleClick = (term: string) => {
  useTasksStore().setActiveFilter(term)
}

const handleTypeClick = (term: string) => {
  useTasksStore().setActiveTypeFilter(term);
}
</script>

<template>
  <div class="bg-white rounded-lg space-y-3">
    <ul class=" flex items-center gap-2">
      <li v-for="filter in filters" :key="filter.name" class="flex-1" @click="handleClick(filter.term)">
        <button
          class="w-full ring-1 ring-gray-200 border-gray p-3 rounded-lg flex items-center justify-center gap-2 font-medium transition-all duration-200"
          :class="{
            'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-700': activeFilter !== filter.term,
            'bg-primary text-white shadow-md hover:bg-primary/90': activeFilter === filter.term,
          }">

          <!-- Available -->
          <svg v-if="filter.term === 'pending'" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20"
            fill="currentColor">
            <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
            <path fill-rule="evenodd"
              d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
              clip-rule="evenodd" />
          </svg>

          <!-- Scheduled -->
          <svg v-if="filter.term === 'finished'" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20"
            fill="currentColor">
            <path fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clip-rule="evenodd" />
          </svg>

          <!-- Completed -->
          <svg v-if="filter.term === 'scheduled'" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20"
            fill="currentColor">
            <path fill-rule="evenodd"
              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
              clip-rule="evenodd" />
          </svg>

          {{ filter.name }}
        </button>
      </li>
    </ul>

    <ul class="flex flex-wrap items-center gap-2">
      <li v-for="typeFilter in typeFilters" :key="typeFilter.term">
        <button
          class="ring-1 ring-gray-200 border-gray px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200"
          :class="{
            'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-700': activeTypeFilter !== typeFilter.term,
            'bg-primary text-white shadow-sm hover:bg-primary/90': activeTypeFilter === typeFilter.term,
          }"
          @click="handleTypeClick(typeFilter.term)"
        >
          {{ typeFilter.name }}
        </button>
      </li>
    </ul>
  </div>
</template>
